import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuParadigmaLateral from '../Navigation/MenuParadigma_lateral';
import { FileText, Plus, Search } from 'lucide-react';

export default function CentralLaudos() {
  const navigate = useNavigate();
  const [laudos, setLaudos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    fetch('/api/laudos/listar.php', { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(d => {
        setLaudos(Array.isArray(d) ? d : (d.data || []));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const filtrados = laudos.filter(l =>
    (l.titulo || '').toLowerCase().includes(busca.toLowerCase()) ||
    (l.processo || '').toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div className="flex min-h-screen bg-[#0A0A0A] text-slate-200">
      <MenuParadigmaLateral />

      <main className="flex-1 p-12 overflow-y-auto">
        <div className="max-w-6xl mx-auto">

          <div className="flex justify-between items-start mb-12">
            <div>
              <h1 className="text-4xl font-black italic uppercase tracking-tighter text-white mb-2">
                Central de Laudos
              </h1>
              <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.4em]">
                Produção Pericial em Andamento
              </p>
            </div>
            <button
              onClick={() => navigate('/laudos/novo')}
              className="flex items-center gap-2 px-6 py-3 rounded-2xl bg-[#e11d48] text-white font-black uppercase tracking-widest text-xs hover:bg-[#be123c] transition-all"
            >
              <Plus size={16} />
              Novo Laudo
            </button>
          </div>

          <div className="mb-8">
            <div className="relative">
              <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
              <input
                type="text"
                value={busca}
                onChange={e => setBusca(e.target.value)}
                placeholder="Buscar por título ou processo..."
                className="w-full bg-white/5 border border-white/5 rounded-2xl py-3 pl-12 pr-4 text-sm text-white placeholder:text-slate-500 outline-none focus:border-white/20"
              />
            </div>
          </div>

          {loading ? (
            <div className="text-center py-20 text-slate-500 text-sm">Carregando...</div>
          ) : filtrados.length === 0 ? (
            <div className="bg-white/[0.02] border border-white/5 rounded-[2rem] p-16 text-center">
              <FileText size={48} className="mx-auto mb-6 text-slate-700" />
              <p className="text-slate-500 font-black uppercase tracking-widest text-xs mb-6">
                Nenhum laudo cadastrado
              </p>
              <button
                onClick={() => navigate('/laudos/novo')}
                className="px-6 py-3 rounded-2xl bg-[#e11d48] text-white font-black uppercase tracking-widest text-xs hover:bg-[#be123c]"
              >
                + Criar primeiro laudo
              </button>
            </div>
          ) : (
            <div className="space-y-3">
              {filtrados.map(l => (
                <div
                  key={l.id}
                  onClick={() => navigate(`/laudos/${l.id}`)}
                  className="bg-white/[0.02] border border-white/5 rounded-2xl p-6 flex items-center gap-6 hover:bg-white/5 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-2xl bg-[#e11d48]/10 border border-[#e11d48]/20 flex items-center justify-center">
                    <FileText size={20} className="text-[#e11d48]" />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-black text-white uppercase tracking-tight">
                      {l.titulo || `Laudo #${l.id}`}
                    </p>
                    <p className="text-[10px] text-slate-500 uppercase tracking-widest">
                      {l.processo || 'Sem processo'} · {l.status || 'Em andamento'}
                    </p>
                  </div>
                  <span className="text-[10px] font-black text-slate-400 uppercase">
                    {l.criado_em ? new Date(l.criado_em).toLocaleDateString('pt-BR') : ''}
                  </span>
                </div>
              ))}
            </div>
          )}

        </div>
      </main>
    </div>
  );
}